module.exports = "<button class=\"sidebar-minimizer\" type=\"button\" appSidebarMinimizer appBrandMinimizer\n(click)=\"isMinimizar()\"></button>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module id = ../../../../../src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module chunks = main